import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
  name: 'nullableNumber'
})
export class NullableNumberPipe implements PipeTransform {

  constructor(private decimalPipe: DecimalPipe) { }

  transform(
    value: number | string | null | undefined,
    format: string = '1.2-2',
    rounding: 'none' | 'up' | 'down' = 'none'
  ): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    const n = Number(value);

    const num =
      rounding === 'up' ? Math.ceil(n) :
        rounding === 'down' ? Math.floor(n) :
          n;

    const formatted = this.decimalPipe.transform(num, format);
    return formatted ? formatted.split(',').join(' ') : '';
  }
}



// WEBPACK FOOTER //
// ./src/app/pipe/nullable.pipe.ts